import { CMSResource } from 'app/resources/cmsresource';
import { KioskResource } from './KioskResource';

export class DepartmentResource extends CMSResource{
    id: number;
	userEmail: string;
    active: boolean;
    nameRo: string;
    nameFr: string;
    nameEn: string;
    nameDe: string;
    responsible: string;
    responsibleEmail: string;
    showNoDaysPeriodAvailability: number;

    showDetailsOnResponsive:boolean=false;
}